import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    sampleNumber: Yup.string().nullable(),
    description: Yup.string().nullable(),
    location:Yup.string().nullable(),
    quantity:Yup.string().nullable(),
    neshapClassification:Yup.string().required(),
    findingComparison:Yup.string().nullable(),
    findingPercentage:Yup.string().nullable(),
    findingType:Yup.string().nullable()
});

